import { useUserGql } from './user/userGql';
import { userSchema } from './user/userSchema';
import { Roles } from 'utils/constants';

export const userModel = {
  gql: useUserGql(),
  schema: userSchema,
  enums: {
    roles: Roles,
  },
};
